// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"85":"a26c2d14","135":"39a631ab","761":"71c7c9d8","763":"c45befc0"}[chunkId] + ".css";
};